<template>
  <div class="row mb-3">
    <div class="col-6">
      <div class="d-table h-100 w-100">
        <h5 class="text-primary font-weight-bold mb-2 text-left d-table-cell align-middle">
          Terpenes
        </h5>
      </div>
    </div>
    <div class="col-6">
      <div class="d-table h-100 w-100 text-right">
        <i class="bushel-icon bushel-3x bushel-terp" />
      </div>
    </div>
    <div
      v-for="terpene in terpenes"
      :key="terpene.id + '_' + terpene.name + '_' + Math.random()"
      class="col-12"
    >
      <div class="row">
        <div class="col-6">
          <div class="d-table h-100 w-100">
            <h6 class="text-light font-weight-normal mb-2 text-left d-table-cell align-middle text-sm">
              {{ terpene.name }}
            </h6>
          </div>
        </div>
        <div class="col-6">
          <div class="d-table h-100 w-100">
            <h6 class="text-medium font-weight-bold mb-2 text-right d-table-cell align-middle text-lowercase">
              {{ terpene.pivot.measurement }}{{ terpene.pivot.measurement_type }}
            </h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    terpenes: { type: Array, required: true },
  },
};
</script>
